export default __webpack_public_path__ + "static/media/avatar_green.94127713.svg";